import {Component, inject, OnInit} from '@angular/core';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';
import {MatIcon} from '@angular/material/icon';
import {PerfilService} from '../shared/service/perfil.service';
import {Perfil} from '../shared/model/perfil/perfil.model';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {MatDialog} from '@angular/material/dialog';
import {ModalCadastroPerfilComponent} from './modal-cadastro-perfil/modal-cadastro-perfil.component';
import {RotinaService} from '../shared/service/rotina.service';
import {
  ModalAssociarPerfilRotinaComponent
} from './modal-associar-perfil-rotina/modal-associar-perfil-rotina.component';
import {IdNome} from '../shared/model/id-nome.model';
import {NgStyle} from '@angular/common';
import {PerfilRotinaService} from '../shared/service/perfil-rotina.service';
import {PerfilRotina} from '../shared/model/perfil/perfil-rotina.model';
import {UsuarioService} from '../shared/service/usuario.service';
import {PerfilRotinaResticaoService} from '../shared/service/perfil-rotina-resticao.service';
import {PerfilRotinaRestricao} from '../shared/model/perfil/perfil-rotina-restricao.model';
import {MatCheckbox} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {MsgService} from '../shared/service/msg.service';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';
import {ModalConfirmacaoComponent} from '../shared/modais/modal-confirmacao/modal-confirmacao.component';

@Component({
  selector: 'app-perfil',
  standalone: true,
  imports: [
    TituloRotinaComponent,
    MatIcon,
    ButtonPadraoComponent,
    NgStyle,
    MatCheckbox,
    FormsModule
  ],
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css'
})
export class PerfilComponent implements OnInit {
  perfis: Perfil[] = [];
  perfilSelecionado?: Perfil;

  rotinasPerfil: IdNome[] = [];
  rotinaSelecionada?: IdNome;

  usuarios: IdNome[] = [];
  restricoesPerfil: PerfilRotinaRestricao[] = [];

  private readonly perfilService = inject(PerfilService);
  private readonly rotinaService = inject(RotinaService);
  private readonly perfilRotinaService = inject(PerfilRotinaService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly perfilRotinaResticaoService = inject(PerfilRotinaResticaoService);
  private readonly dialog = inject(MatDialog);
  private readonly msgService = inject(MsgService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.buscarPerfisPorGrupo();
  }

  buscarPerfisPorGrupo() {
    this.perfilService.buscarPerfisPorGrupo().subscribe({
      next: res => this.perfis = res
    });
  }

  buscarRotinasSelectPorPerfil(perfilId: number) {
    this.rotinaService.buscarRotinaSelectPorPerfil(perfilId).subscribe({
      next: res => this.rotinasPerfil = res
    });
  }

  buscarUsuariosPorPerfil(perfilId: number) {
    this.usuarioService.buscarUsuariosPorPerfil(perfilId).subscribe({
      next: res => this.usuarios = res
    });
  }

  buscarPerfilRotinaRestricaoPorPerfilERotina(perfilId: number, rotinaId: number) {
    this.perfilRotinaResticaoService.buscarPerfilRotinaRestricaoPorPerfilERotina(perfilId, rotinaId).subscribe({
      next: res => this.restricoesPerfil = res
    });
  }

  abrirModalCadastroPerfil(perfil?: Perfil) {
    const perfilEnvio = new Perfil(perfil?.id, perfil?.nome, perfil?.ativo, perfil?.admin);
    const dialogRef = this.dialog.open(ModalCadastroPerfilComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { perfil: perfilEnvio },
      panelClass: 'slide-modal',
      disableClose: true
    })

      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) {
          dialogRef.close();
        }
      });

    dialogRef.afterClosed().subscribe({
      next: (res: Perfil) => {
        if (res) {
          this.perfilService.salvarPerfil(res).subscribe({
            next: () => {
              this.buscarPerfisPorGrupo();
              this.msgService.msgSucesso('Perfil salvo com sucesso.');
            }
          });
        }
      }
    });
  }

  abrirModalAssociarPerfilRotina() {
    if (this.perfilSelecionado) {
      const dialogRef = this.dialog.open(ModalAssociarPerfilRotinaComponent, {
        width: '361px', height: '100vh',
        position: {
          top: '0',
          right: '0'
        },
        data: { rotinasAssociadas: this.rotinasPerfil },
        disableClose: true
      })

        dialogRef.backdropClick().subscribe(() => {
          const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
            window.confirm('Pode possuir alterações não salvas, deseja fechar?');
          if (podeFechar) {
            dialogRef.close();
          }
        });


      dialogRef.afterClosed().subscribe({
        next: (res: IdNome[]) => {
          if (res) {
            this.perfilRotinaService.salvarPerfilRotina(res.map(r => new PerfilRotina(this.perfilSelecionado!, r))).subscribe({
              next: () => {
                this.rotinaSelecionada = undefined;
                this.restricoesPerfil = [];
                this.buscarRotinasSelectPorPerfil(this.perfilSelecionado!.id!);
                this.msgService.msgSucesso('Rotina vinculada com sucesso.');
              }
            });
          }
        }
      });
    }
  }

  selecionarPerfil(perfil: Perfil) {
    this.perfilSelecionado = perfil;
    this.rotinaSelecionada = undefined;
    this.restricoesPerfil = [];
    if (perfil.id) {
      this.buscarRotinasSelectPorPerfil(perfil.id);
      this.buscarUsuariosPorPerfil(perfil.id);
    }
  }

  selecionarRotina(rotina: IdNome) {
    this.rotinaSelecionada = rotina;
    this.restricoesPerfil = [];
    this.buscarPerfilRotinaRestricaoPorPerfilERotina(this.perfilSelecionado!.id!, rotina.id!);
  }

  deletePerfilRotina(rotina: IdNome) {
    this.dialog.open(ModalConfirmacaoComponent, {
      height: '200px',
      data: { texto: 'Deseja desvincular a rotina do perfil?' }
    }).afterClosed().subscribe({
      next: (res: Perfil) => {
        if (res) {
          if (this.perfilSelecionado) {
            this.perfilRotinaService.deletePerfilRotina(rotina.id!, this.perfilSelecionado.id!).subscribe({
              next: () => {
                this.rotinaSelecionada = undefined;
                this.restricoesPerfil = [];
                this.buscarRotinasSelectPorPerfil(this.perfilSelecionado!.id!);
                this.msgService.msgSucesso('Rotina desvinculada com sucesso');
              }
            });
          }
        }
      }
    });
  }

  alterarPermicao(restricao: PerfilRotinaRestricao) {
    this.perfilRotinaResticaoService.alterarPermicao(restricao).subscribe({
      next: () => {
        this.buscarPerfilRotinaRestricaoPorPerfilERotina(this.perfilSelecionado!.id!, this.rotinaSelecionada!.id!);
        this.msgService.msgSucesso('Restrição alterada com sucesso.');
      }
    });
  }
}
